export default __webpack_public_path__ + "static/ulatowska-78136a5d8fd2518d7a44edfbc809162f.jpg";